import config from '../config/config'

export default (product) => {
    let cardActivationDate = new Date(product.launchDate)
    cardActivationDate.setDate(cardActivationDate.getDate() - config.adyenRaffleLength);
    return cardActivationDate
}